import { render, staticRenderFns } from "./action-row.vue?vue&type=template&id=6b76b85f&scoped=true&"
import script from "./action-row.vue?vue&type=script&lang=js&"
export * from "./action-row.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b76b85f",
  null
  
)

export default component.exports